// Security Profiles Main Page component (imported and rendered in SecurityProfiles.js in Routes directory)
// This component is in form of a function component, all the data related to Security settings
// main page is displayed through this component, since this is the main component, it is the parent
// to other child components imported at the top level, such as <ContentHeader/>, etc.
// Stylesheets related to this page are imported here (SecurityProfiles.scss)

import React, { useState, useEffect, useCallback } from "react";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";
import { NavLink } from "react-router-dom";
import Pencil from "../../../../../Assets/Images/pencil.svg";
import Plus from "../../../../../Assets/Images/ButtonPlus.svg";
import Delete from "../../../../../Assets/Images/delete.svg";
import EmptyState from "../../../../../Assets/Images/EmptyState.svg";
import Up from "../../../../../Assets/Images/up.svg";
import "../../../../../Assets/Styles/SecurityProfiles.scss";
import "../../../../../Assets/Styles/Pagination.scss";
import Collapsible from "react-collapsible";
import SearchInput from "../../ShareElements/SearchInput/SearchInput";
import MultiSelect from "../../ShareElements/Select/MultiSelect";
import Alert from "../../ShareElements/Alert/Alert";
import DesktopOnlyPageOverlay from "../../ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import TableFilter from "../../ShareElements/TableFilter/TableFilter";
import axios from "axios";
import { Config } from "../../../../../Config";
import MultipleDeleteAlert from "../../ShareElements/Alert/MultipleItemDeleteAlert";
import ErrorModal from "../../ShareElements/Alert/ErrorModal";
import PaginationRowSelector from "../Components/PaginationRowSelector";

const SecurityProfiles = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const [ProfileList, setProfileList] = useState([]);
  const [ItemIDs, setItemIDs] = useState([]); // used for checkboxes
  const [Pages, setPages] = useState([]);
  const [PageInfo, setPageInfo] = useState({
    FirstPage: 1,
    FirstDotsShown: false,
    MiddlePage: 3,
    LastDotsShown: false,
    LastPage: 7,
    ActivePage: 1,
  });
  const [TotalElements, setTotalElements] = useState();
  const [PreviousModalId, setPrevModalId] = useState();
  const [ItemIdToDelete, setIdToDelete] = useState("");
  const [SelectedProfiles, setSelectedProfiles] = useState([]);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);
  const [DeleteMultipleIsOpen, setDeleteMultipleIsOpen] = useState(false);
  const [PrevId, setPrevId] = useState("");
  // *filter data with initial values* //
  const [Size] = useState(5);
  const [IsActive, setIsActive] = useState(true);
  const [NameLike, setNameLike] = useState("");
  const [Direction, setDirection] = useState("DESC");
  const [Start, setStart] = useState(0);
  // ** //
  const [AllIds, setAllIds] = useState([]);
  const [ACLs, setACLs] = useState([]);
  const [ResultIsEmpty, setResultIsEmpty] = useState(false);
  const [DeleteError, setDeleteError] = useState({
    isShown: false,
    currentlyUsed: [],
  });
  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
    { name: 15, id: 15 },
    { name: 20, id: 20 },
    { name: 25, id: 25 },
    { name: 50, id: 50 },
  ]);
  const [SelectedSize, setSelectedSize] = useState(5);

  useEffect(() => {
    getInitialProfilesList();
    fetchACLs();
    // removing localstorage variables created during add profile.
    window.localStorage.removeItem("CreatedProfileId");
    window.localStorage.removeItem("CreatedProfileNameString");
    window.localStorage.removeItem("CreatedProfileDesc");
    window.localStorage.removeItem("Enabled");
    window.localStorage.removeItem("MappingCreated");
    window.localStorage.removeItem("Type");
    window.localStorage.removeItem("TypeName");
  }, []);
  useEffect(() => {
    updatePagination();
  }, [TotalElements]);

  const fetchACLs = () => {
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        criteria: {
          nameLike: document.getElementById("search-input").value,
        },
        size: 100,
        start: parseInt(document.getElementById("Start").value),
        sorts: [{ direction: Direction, fieldName: "name" }],
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setACLs(Res.data.results);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // Component logical functions:
  const getInitialProfilesList = () => {
    var Data = JSON.stringify({
      size: Size,
      start: 0,
      sorts: [{ direction: "DESC", fieldName: "name" }],
    });

    var Req = {
      method: "post",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setProfileList(Res.data.results);
        createPagination(Res.data.totalElements);
        if (Res.data.results.length === 0) {
          setResultIsEmpty(true);
        } else {
          setResultIsEmpty(false);
        }
        setTotalElements(Res.data.totalElements);
        let IDs = [];
        Res.data.results.map((Item) => {
          IDs.push(Item.id);
        });
        setItemIDs(IDs);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  // * This function used for fetching filtered data from the server
  // * Parameters based on backend and renamed and stored as component state
  //   respectively as below:
  // size (Int): number of elements displayed in the page
  // enabled(boolean): active or inactive status
  // nameLike (string): a string value to search names
  // direction (string) : is either DESC (decending) or ASC (ascending)
  // start (Int): the index of the starting page (current page usually)
  const getFilteredData = (Size, Start, IsActivesOnly, Direction) => {
    console.log("filtered data size", Size);
    console.log("selectedSize", SelectedSize);
    // ACL filter
    let ReqACLs = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        size: 100,
        start: 0,
        sorts: [{ direction: Direction, fieldName: "name" }],
      },
    };

    var SelectedACLs = [];
    axios(ReqACLs)
      .then((Res) => {
        console.log(Res);

        Res.data.results.map((acl) => {
          if (
            document
              .getElementById("icon-" + acl.id)
              .classList.contains("feather-check-selected")
          ) {
            SelectedACLs.push(acl.id);
            console.log("after push selected acls", SelectedACLs);
          }
        });

        var Data = {
          criteria: {
            nameLike: document.getElementById("search-input").value,
            aclIds: [],
          },
          size: Size,
          start: Start,
          sorts: [{ direction: "DESC", fieldName: "name" }],
        };

        if (
          document
            .getElementById("Names-pointer-down")
            .classList.contains("active-filter")
        ) {
          Data.sorts[0] = { direction: "DESC", fieldName: "name" };
        } else if (
          document
            .getElementById("Names-pointer-up")
            .classList.contains("active-filter")
        ) {
          Data.sorts[0] = { direction: "ASC", fieldName: "name" };
        }

        if (
          document
            .getElementById("Status-pointer-down")
            .classList.contains("active-filter")
        ) {
          Data.sorts[0] = { direction: "DESC", fieldName: "enabled" };
        } else if (
          document
            .getElementById("Status-pointer-up")
            .classList.contains("active-filter")
        ) {
          Data.sorts[0] = { direction: "ASC", fieldName: "enabled" };
        }

        let SelectedStatuses = Array(
          document.getElementById("Status-filter").value
        );
        if (SelectedStatuses.length === 2 || SelectedStatuses.length === 3) {
          document.getElementById("Status").value = "0";
        } else if (
          SelectedStatuses.length === 1 &&
          SelectedStatuses[0] === translateText("active")
        ) {
          document.getElementById("Status").value = "1";
        } else if (
          SelectedStatuses.length === 1 &&
          SelectedStatuses[0] == translateText("inactive")
        ) {
          document.getElementById("Status").value = "2";
        } else {
          setIsActive(undefined);
        }

        let StatusValue = parseInt(document.getElementById("Status").value);
        if (StatusValue === 1) {
          Data.criteria.enabled = true;
        } else if (StatusValue === 2) {
          Data.criteria.enabled = false;
        } else {
          if (Data.criteria.enabled !== undefined) {
            delete Data.criteria.enabled;
          }
        }

        console.log("selected ACLS", SelectedACLs);
        if (SelectedACLs.length > 0) {
          Data.criteria.aclIds = SelectedACLs;
        } else {
          delete Data.criteria.aclIds;
        }

        var Req = {
          method: "post",
          baseURL:
            window._env_.API_URL + Config.AuthBaseURL + "/api/role/search",
          headers: {
            Authorization: "Bearer " + window.localStorage.getItem("Token"),
            "Content-Type": "application/json",
          },
          data: JSON.stringify(Data),
        };
        axios(Req)
          .then((Res) => {
            console.log(Res);
            if (Res.data.results.length === 0) {
              setResultIsEmpty(true);
            } else {
              setResultIsEmpty(false);
            }
            setProfileList(Res.data.results);
            setTotalElements(Res.data.totalElements);
            createPagination(Res.data.totalElements);
            let IDs = [];
            Res.data.results.map((Item) => {
              IDs.push(Item.id);
            });
            setItemIDs(IDs);
            if (Start === 0) {
              updatePaginationActiveClass("1-page-btn");
            } else {
              updatePaginationActiveClass(
                document.getElementById("PrevId").value
              );
            }
            // deselecting the checkboxes after updating page data
            uncheckAllCheckboxes();
          })
          .catch((Err) => {
            console.log(Err);
          });
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // Name sort function (on table head)
  const filterByName = () => {
    document
      .getElementById("Status-pointer-up")
      .classList.remove("active-filter");
    document
      .getElementById("Status-pointer-down")
      .classList.remove("active-filter");

    if (Direction === "DESC") {
      getFilteredData(SelectedSize, 0, null, "DESC");
      setDirection("DESC");
    } else {
      getFilteredData(SelectedSize, 0, null, "ASC");
      setDirection("ASC");
    }
  };

  const updatePagination = () => {
    let Count = Math.ceil(TotalElements / SelectedSize);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const createPagination = (TotalCount) => {
    let Count = Math.ceil(TotalCount / SelectedSize);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };

  // Opens and closes the small modal displayed for each row in the table based on conditions
  const openModal = (i) => {
    setPrevId(i);
    // this is a global variable set every time the user clicks on
    // a context menu, to get the permission
    // id and use it in API requests
    window.localStorage.setItem("PermissionId", i);

    setPrevModalId("modal-" + i);
    if (PreviousModalId !== undefined) {
      if (document.getElementById("modal-" + i).style.display === "block") {
        document.getElementById("modal-" + i).style.display = "none";
      } else if (
        document.getElementById("modal-" + i).style.display === "none" &&
        PreviousModalId === "modal-" + i
      ) {
        document.getElementById("modal-" + i).style.display = "block";
      } else {
        document.getElementById("modal-" + i).style.display = "block";
        document.getElementById(PreviousModalId).style.display = "none";
      }
    } else {
      document.getElementById("modal-" + i).style.display = "block";
    }
  };
  // The two following functions handle icon rotation for the ViewAll button based
  // on their ID which is their index in the array from which they are mapped
  // plus the string "-trigger"
  // The open and close states are added and removed ass classNames to apply the state
  const addOpenState = (i) => {
    document
      .getElementById(i + "-trigger")
      .classList.add("trigger-icon-opened");
    document.getElementById(i + "-trigger-text").innerHTML =
      translateText("view_less");
  };
  const removeOpenState = (i) => {
    document
      .getElementById(i + "-trigger")
      .classList.remove("trigger-icon-opened");
    document.getElementById(i + "-trigger-text").innerHTML =
      translateText("view_all");
  };
  const enableDelete = () => {
    document.getElementById("delete-btn").classList.remove("disabled");
  };
  const disableDelete = () => {
    document.getElementById("delete-btn").classList.add("disabled");
  };

  // updates the delete button status based on the count of items selected and updates the list accordingly
  const handleItemSelect = () => {
    let Selected = [];
    ProfileList.map((Item) => {
      if (document.getElementById("checkbox-" + Item.id).checked) {
        Selected.push(Item.id);
      }
    });
    if (Selected.length === 0) {
      disableDelete();
    } else {
      enableDelete();
    }
  };

  // In this function, we check if the user has previously selected all items checkbox or not, then act
  // accordingly, where we select the unchecked items based on their ID which is their index inside the
  // array plus the string "checkbox-" like "checkbox-1" and so on, then we enable the delete button if
  // there are checked elements.
  const checkAll = () => {
    let DefaultIds = [
      "57ce2cd1-7575-4cab-b1e1-ff6e1ef1f7a2",
      "615d1796-b434-481d-af59-c178bd338cdd",
      "4442d966-d648-4e58-b971-85f0667ab970",
    ];

    if (document.getElementById("checkbox-all").checked) {
      ItemIDs.map((Item) => {
        if (DefaultIds.indexOf(Item) === -1) {
          setAllIds(ItemIDs);
          if (document.getElementById("checkbox-" + Item).checked) {
          } else {
            document.getElementById("checkbox-" + Item).checked = true;
            enableDelete();
            setSelectedProfiles(ProfileList);
          }
        }
      });
    } else {
      setAllIds([]);
      ItemIDs.map((Item) => {
        if (
          document.getElementById("checkbox-" + Item).checked &&
          DefaultIds.indexOf(Item) === -1
        ) {
          document.getElementById("checkbox-" + Item).checked = false;
          disableDelete();
          setSelectedProfiles([]);
        }
      });
    }
  };

  const uncheckAllCheckboxes = () => {
    document.getElementById("checkbox-all").checked = true;
    document.getElementById("checkbox-all").click();
    disableDelete();
    setSelectedProfiles([]);
  };

  const showDeleteAlert = (id) => {
    document.getElementById("modal-" + id).style.display = "none";
    setIdToDelete(id);
    setDeleteIsOpen(true);
  };
  // approval of delete will trigger this function to request deleting security profile
  const acceptDelete = () => {
    let Req = {
      method: "DELETE",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: { id: ItemIdToDelete },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeleteIsOpen(false);
        setPrevModalId(undefined);
        getInitialProfilesList();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.status === 403) {
          setDeleteIsOpen(false);
          setDeleteError({
            isShown: true,
            currentlyUsed: Err.response.data.messages,
          });
        }
      });
  };
  const requestPageNumber = useCallback(
    (PageNumber) => {
      // unchecking the select all checkbox
      document.getElementById("checkbox-all").checked = false;
      // disabling bulk delete
      disableDelete();
      // removing selected profiles from state
      setSelectedProfiles([]);

      let NewStart = (PageNumber - 1) * SelectedSize;
      document.getElementById("Start").value = NewStart;
      document.getElementById("PrevId").value = PageNumber + "-page-btn";
      setPrevId(PageNumber + "-page-btn");
      updatePaginationActiveClass(document.getElementById("PrevId").value);
      setStart(NewStart);
      getFilteredData(SelectedSize, NewStart, null, Direction);
      if (PageNumber === 1) {
        document.getElementById("prev-page").classList.add("page-btn-disabled");
      } else {
        document
          .getElementById("prev-page")
          .classList.remove("page-btn-disabled");
      }
      if (PageNumber === Pages.length) {
        document.getElementById("next-page").classList.add("page-btn-disabled");
      } else {
        document
          .getElementById("next-page")
          .classList.remove("page-btn-disabled");
      }
    },
    [Start, SelectedSize]
  );
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
    if (NextPage > 1 && Pages.length > 1) {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
    if (PrevPage === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
  };
  const updatePaginationActiveClass = (CurrentId) => {
    if (document.getElementById("1-page-btn") !== null) {
      if (PrevId.length === 0 || PrevId === CurrentId) {
        document.getElementById("1-page-btn").classList.remove("active-page");
        document.getElementById(CurrentId).classList.add("active-page");
      } else {
        if (document.getElementById(PrevId)) {
          document.getElementById(PrevId).classList.remove("active-page");
        }
        if (document.getElementById(CurrentId)) {
          document.getElementById(CurrentId).classList.add("active-page");
        }
      }
    }
  };

  const cancelDelete = () => {
    setDeleteIsOpen(false);
  };

  const editProfile = (Profile) => {
    let ProfileObject = JSON.stringify(Profile);
    let ProfileBase64 = Buffer.from(ProfileObject).toString("base64");
    window.localStorage.setItem("SelectedProfile", ProfileBase64);
    window.localStorage.setItem("EditProfileId", Profile.id);
    document.getElementById("edit-trigger").click();
    console.log(Profile);
  };

  const handleListByStatus = useCallback(() => {}, [IsActive]);

  const clearStatusFilter = () => {
    document.getElementById("Status").value = "2";
    getFilteredData(SelectedSize, 0, null, Direction);
  };

  const handleListByStatusFilterOnly = () => {
    document
      .getElementById("Names-pointer-up")
      .classList.remove("active-filter");
    document
      .getElementById("Names-pointer-down")
      .classList.remove("active-filter");
    if (document.getElementById("Status-pointer-up").classList.length === 2) {
      document.getElementById("Status").value = 1;
    } else if (
      document.getElementById("Status-pointer-down").classList.length === 2
    ) {
      document.getElementById("Status").value = 2;
    } else {
      document.getElementById("Status").value = 0;
    }
    getFilteredData(SelectedSize, 0, null, Direction);
  };

  const deleteMultipleItems = () => {
    setDeleteMultipleIsOpen(true);
  };
  const acceptDeleteMultiple = () => {
    let Selected = [];
    ItemIDs.map((Id) => {
      if (document.getElementById("checkbox-" + Id).checked) {
        Selected.push(Id);
      }
    });

    let Data = {};
    Data = Selected;

    setDeleteMultipleIsOpen(false);
    if (document.getElementById("checkbox-all").checked) {
      document.getElementById("checkbox-all").click();
    }
    let Req = {
      method: "DELETE",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role/batch",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        ids: Data,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeleteIsOpen(false);
        setPrevModalId(undefined);
        getInitialProfilesList();
        disableDelete();
        uncheckAllCheckboxes();
        // this condition handles the use-case where an item is selected for deleting but it
        // is currently assigned to at least 1 user to display the error message with the list of
        // already assigned profiles.
        if (Res.data.currentlyUsed.length > 0) {
          setDeleteError({
            isShown: true,
            currentlyUsed: Res.data.currentlyUsed,
          });
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const cancelDeleteMultiple = () => {
    setDeleteMultipleIsOpen(false);
  };

  const resetFilters = () => {
    if (document.getElementById("ACL-clear") !== null) {
      document.getElementById("ACL-clear").click();
    }
    if (document.getElementById("Status-clear") !== null) {
      document.getElementById("Status-clear").click();
    }
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
    getFilteredData(SelectedSize, 0, null, Direction);
  };

  // The Ids that are in the condition are default security profile Ids and they
  // should not be edited or deleted, so we disable the context menu by adding the
  // disabled className
  const handleMenuClassName = (Id) => {
    if (
      Id === "57ce2cd1-7575-4cab-b1e1-ff6e1ef1f7a2" ||
      Id === "615d1796-b434-481d-af59-c178bd338cdd" ||
      Id === "4442d966-d648-4e58-b971-85f0667ab970"
    ) {
      return "modal-body double-item modal-body-disabled";
    } else {
      return "modal-body double-item";
    }
  };

  const generateChips = (Profile) => {
    var ACLS = Profile.acls;
    if (ACLS.length === 0) {
      return (
        <section className="chip-holder">
          {[1, 2, 3, 4, 5].map((item, idx) => (
            <p className="small-chip" key={idx}>
              {"All data (default)"}
            </p>
          ))}
        </section>
      );
    } else {
      if (ACLS.length <= 5) {
        return (
          <section className="chip-holder">
            {ACLS.map((ACL, idx) => (
              <p className="small-chip" key={idx}>
                {ACL.name}
              </p>
            ))}
          </section>
        );
      } else {
        let TriggerItems = ACLS.splice(0, 4);
        let MoreItems = ACLS.splice(5, ACLS.length);
        return (
          <Collapsible
            onOpening={() => addOpenState(Profile.id)}
            onClosing={() => removeOpenState(Profile.id)}
            trigger={
              <section className="chip-holder">
                {TriggerItems.map((Item) => (
                  <p className="small-chip" key={Item.name}>
                    {Item.name}
                  </p>
                ))}
                <button className="trig-more">
                  <p id={Profile.id + "-trigger-text"}>
                    {translateText("view_all")}
                  </p>
                  <img
                    className="trigger-icon-closed"
                    id={Profile.id + "-trigger"}
                    alt=""
                    src={Up}
                  />
                </button>
              </section>
            }
          >
            <section className="chip-holder all-data">
              {MoreItems.map((Item) => (
                <p className="small-chip">{Item.name}</p>
              ))}
            </section>
          </Collapsible>
        );
      }
    }
  };

  useEffect(() => {
    if (document.getElementById("1-page-btn") !== null) {
      document.getElementById("1-page-btn").click();
    }
  }, [SelectedSize]);

  const setSize = () => {
    setSelectedSize(
      parseInt(document.getElementById("pre-selected-row-per-page").innerHTML)
    );
  };

  return (
    <React.Fragment>
      <input className="hidden" type="number" id="Start" />
      <input
        className="hidden"
        type="number"
        id="Status"
        value="0"
        max="2"
        min="0"
      />
      <input className="hidden" id="PrevId" defaultValue="1-page-btn" />
      <DesktopOnlyPageOverlay LangData={props.LangData} />
      {DeleteMultipleIsOpen ? (
        <MultipleDeleteAlert
          acceptDeleteMultiple={() => acceptDeleteMultiple()}
          cancelDeleteMultiple={() => cancelDeleteMultiple()}
          IsDelete
          LangData={props.LangData}
        />
      ) : null}
      {DeleteIsOpen ? (
        <Alert
          acceptDelete={() => acceptDelete()}
          cancelDelete={() => cancelDelete()}
          IsDelete
          LangData={props.LangData}
        />
      ) : null}
      {DeleteError.isShown ? (
        <ErrorModal
          Data={DeleteError.currentlyUsed}
          Close={() => setDeleteError({ isShown: false })}
          Type={"security profile(s)"}
          LangData={props.LangData}
        />
      ) : null}
      <div className="main-content security-settings security-profiles">
        <ContentHeader PageName={translateText("security_profiles")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("security_settings")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("security_profiles")}</p>
          </div>
        </div>
        <div className="actions">
          <section className="button-group">
            <button
              onClick={() => deleteMultipleItems()}
              id="delete-btn"
              className="act disabled"
            >
              <i className="feather-trash"></i>
              <p>{translateText("delete")}</p>
            </button>
          </section>
          <NavLink to="/addProfile">
            <button className="add-user">
              <img alt="" src={Plus} /> <p>{translateText("new_profile")}</p>
            </button>
          </NavLink>
        </div>
        <div className="filters">
          <p className="title-text">{translateText("filters")}</p>
          <div className="flex">
            <SearchInput
              OnChange={() => getFilteredData(SelectedSize, 0, null, Direction)}
              Placeholder={translateText("search") + " ..."}
            />
            <MultiSelect
              Name={translateText("access_control_lists")}
              Initial={"All records"}
              Options={ACLs}
              ChangeHandler={() =>
                getFilteredData(SelectedSize, 0, null, Direction)
              }
              IsWithId
              Id="ACL"
            />
            <MultiSelect
              Name={translateText("status")}
              Initial={"All Statuses"}
              Options={[translateText("active"), translateText("inactive")]}
              Id="Status"
              ChangeHandler={() =>
                getFilteredData(SelectedSize, 0, null, Direction)
              }
              ClearFunction={() => clearStatusFilter()}
            />
          </div>
        </div>
        <div className="information">
          <div className="data-table">
            <section className="table-header flex">
              <div className="xsmall">
                <label className="blue-checkbox-rounded-label">
                  <input
                    onChange={() => checkAll()}
                    type="checkbox"
                    id="checkbox-all"
                    class="blue-checkbox"
                  />
                  <i className="check-all"></i>
                </label>
              </div>
              <TableFilter
                className="large with-padding-left sorts"
                Name={translateText("names")}
                Id="Names"
                IsActive
                ChangeEvent={() => filterByName()}
              />
              <div className="large">
                {translateText("access_control_lists")}
              </div>
              <TableFilter
                IsActive={false}
                className="medium sorts"
                Name={translateText("status")}
                Id="Status"
                ChangeEvent={() => handleListByStatusFilterOnly()}
              />
            </section>
            <div className="table-body">
              {ProfileList.map((Profile) => (
                <div className="table-item flex" key={Profile.id}>
                  <div className="xsmall">
                    {Profile.id === "57ce2cd1-7575-4cab-b1e1-ff6e1ef1f7a2" ||
                    Profile.id === "615d1796-b434-481d-af59-c178bd338cdd" ||
                    Profile.id === "4442d966-d648-4e58-b971-85f0667ab970" ? (
                      <label className="blue-checkbox-rounded-label disabled-checkbox-wrapper">
                        <input
                          onChange={() => handleItemSelect()}
                          type="checkbox"
                          class="blue-checkbox"
                          id={"checkbox-" + Profile.id}
                        />
                        <i></i>
                      </label>
                    ) : (
                      <label className="blue-checkbox-rounded-label">
                        <input
                          onChange={() => handleItemSelect()}
                          type="checkbox"
                          class="blue-checkbox"
                          id={"checkbox-" + Profile.id}
                        />
                        <i></i>
                      </label>
                    )}
                  </div>
                  <div className="large with-padding-left name">
                    {Profile.name}
                  </div>
                  <div className="large profiles">{generateChips(Profile)}</div>
                  <div className="medium status">
                    {Profile.enabled || Profile.enabled === null ? (
                      <React.Fragment>
                        <section className="active"></section>
                        <p>{translateText("active")}</p>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <section className="deactive"></section>
                        <p>{translateText("inactive")}</p>
                      </React.Fragment>
                    )}
                  </div>
                  <div className="more">
                    <button
                      onClick={() => openModal(Profile.id)}
                      className="btn-more"
                    ></button>
                    <div className="modal-space" id={"modal-" + Profile.id}>
                      <div
                        className="outline"
                        onClick={() => openModal(PrevId)}
                      ></div>
                      <div className={handleMenuClassName(Profile.id)}>
                        <NavLink
                          id="edit-trigger"
                          to={`/editProfile`}
                        ></NavLink>
                        <button
                          onClick={() => editProfile(Profile)}
                          className="btn"
                        >
                          <img alt="" src={Pencil} />
                          <div className="btn-text">
                            <p>{translateText("edit")}</p>
                            <p>{translateText("edit_profile")}</p>
                          </div>
                        </button>
                        <button
                          className="btn"
                          onClick={() => showDeleteAlert(Profile.id)}
                        >
                          <img alt="" src={Delete} />
                          <div className="btn-text">
                            <p>{translateText("delete")}</p>
                            <p>{translateText("delete_profile_permenantly")}</p>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {ResultIsEmpty ? (
            <div className="empty-state">
              <img alt="" src={EmptyState} />
              <p>{translateText("security_profiles_empty_state")}</p>
              <button onClick={() => resetFilters()}>
                {translateText("reset_filters")}
              </button>
            </div>
          ) : (
            <div className="page-footer">
              <section className="pagination-holder">
                <button
                  onClick={() => requestPrevPage()}
                  id="prev-page"
                  className="page-btn page-btn-disabled"
                >
                  <i className="feather-chevron-left"></i>
                </button>
                <React.Fragment>
                  {Pages.length < 6 ? (
                    <React.Fragment>
                      {Pages.map((Page) => (
                        <React.Fragment>
                          {Page === 1 ? (
                            <button
                              key={Page}
                              onClick={() => requestPageNumber(Page)}
                              className="page-btn active-page"
                              id={Page + "-page-btn"}
                            >
                              {Page}
                            </button>
                          ) : (
                            <button
                              key={Page}
                              onClick={() => requestPageNumber(Page)}
                              className="page-btn"
                              id={Page + "-page-btn"}
                            >
                              {Page}
                            </button>
                          )}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <button
                        onClick={() => requestPageNumber(1)}
                        className="page-btn active-page"
                        id={1 + "-page-btn"}
                      >
                        {1}
                      </button>
                      {PageInfo.FirstDotsShown ? <p>...</p> : null}
                      <button
                        onClick={() =>
                          requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                        }
                        className="page-btn"
                        id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                      >
                        {parseInt(PageInfo.MiddlePage - 1)}
                      </button>
                      {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                        <button
                          onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                          className="page-btn"
                          id={PageInfo.MiddlePage + "-page-btn"}
                        >
                          {PageInfo.MiddlePage}
                        </button>
                      )}
                      {parseInt(PageInfo.MiddlePage + 1) >=
                      PageInfo.LastPage ? null : (
                        <button
                          onClick={() =>
                            requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                          }
                          className="page-btn "
                          id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                        >
                          {parseInt(PageInfo.MiddlePage + 1)}
                        </button>
                      )}
                      {!PageInfo.LastDotsShown ? <p>...</p> : null}
                      <button
                        onClick={() => requestPageNumber(PageInfo.LastPage)}
                        className="page-btn"
                        id={PageInfo.LastPage + "-page-btn"}
                      >
                        {PageInfo.LastPage}
                      </button>
                    </React.Fragment>
                  )}
                </React.Fragment>
                <button
                  onClick={() => requestNextPage()}
                  id="next-page"
                  className="page-btn"
                >
                  <i className="feather-chevron-right"></i>
                </button>
              </section>
              <p className="small-info-footer">
                {translateText("showing")} {Start + 1} {translateText("to")}{" "}
                {Start + SelectedSize <= TotalElements
                  ? Start + SelectedSize
                  : TotalElements}{" "}
                {translateText("of")} {TotalElements} {translateText("items")}.
              </p>
              <PaginationRowSelector
                SizeOptions={SizeOptions}
                setSize={() => setSize()}
                LangData={props.LangData}
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default SecurityProfiles;
